"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InngestExecution = exports.PREFERRED_EXECUTION_VERSION = exports.ExecutionVersion = void 0;
const debug_1 = __importDefault(require("debug"));
const consts_1 = require("../../helpers/consts");
var ExecutionVersion;
(function (ExecutionVersion) {
    ExecutionVersion[ExecutionVersion["V0"] = 0] = "V0";
    ExecutionVersion[ExecutionVersion["V1"] = 1] = "V1";
})(ExecutionVersion || (exports.ExecutionVersion = ExecutionVersion = {}));
exports.PREFERRED_EXECUTION_VERSION = ExecutionVersion.V1;
class InngestExecution {
    constructor(options) {
        this.options = options;
        this.debug = (0, debug_1.default)(`${consts_1.debugPrefix}:${this.options.runId}`);
    }
}
exports.InngestExecution = InngestExecution;
//# sourceMappingURL=InngestExecution.js.map